import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => {
    return {
        dateTime: {
            display: 'inline-block',
        },
        circleDisplay: (props) => {
            let circleSize;
            switch (props.size) {
                case 'medium':
                    circleSize = '8px';
                    break;
                case 'large':
                    circleSize = '12px';
                    break;
                case 'small':
                    circleSize = '6px';
                    break;
                default:
                    circleSize = '10px';
            }

            let color = props.backgroundColor.includes('#') ? props.backgroundColor : theme.palette[props.backgroundColor].main;

            return {
                display: 'inline-block',
                height: props.circleSize ? props.circleSize : circleSize,
                width: props.circleSize ? props.circleSize : circleSize,
                backgroundColor: color,
                borderRadius: '50%',
                border: `1px solid ${color}`,
            };
        },
        textDisplay: (props) => {
            let fontSize;
            switch (props.size) {
                case 'medium':
                    fontSize = '12px';
                    break;
                case 'large':
                    fontSize = '16px';
                    break;
                case 'small':
                    fontSize = '10px';
                    break;
                default:
                    fontSize = '14px';
            }

            return {
                '&.MuiTypography-root': {
                    fontSize: props.fontSize ? props.fontSize : fontSize,
                    display: 'inline',
                },
            };
        },
    };
});

export default useStyles;
